import React from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import List from "../../styleHelper/List"
import Accordion from 'react-bootstrap/Accordion';
import Header from "../../sections/Header/Header"
import Footer from "../../sections/Footer"

export default function Guide(props){
    const categoryImage = {
        title:"راهنما",
        type:"imageList",
        sub:[
            {
                title:"اولی",
                image:"ss",
                link:"/1",
                hasSub:false
            },
            {
                title:"دومی",
                image:"ss",
                link:"/1",
                hasSub:false
            },
        ]
    }
    const categoryList = {
        title:"راهنما",
        type:"linkList",
        sub:[
            {
                title:"اولی",
                image:"ss",
                link:"/1",
                hasSub:false
            },
            {
                title:"دومی",
                image:"ss",
                link:"/1",
                hasSub:false
            },
        ]
    }
    const contentAcc =[
        {
            title:"اولی",
            content:"متن اولی",
        },
        {
            title:"دومی",
            content:"متن دومی",
        },
        {
            title:"سومی",
            content:"متن سومی",
        },
    ]
    return(
        <div id="landing">
            <Header/>
        <div className="guide page">
            <Container>
                <h1>{categoryImage.title}</h1>
                {categoryImage.type === "imageList" ?
                    <Row>
                        {categoryImage.sub.map((s)=>{
                            return (
                                <Col>
                                    <Card className="text-center">
                                        <Card.Body>
                                            <Card.Img variant="top" src={s.image} />
                                            <Card.Title>{s.title}</Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )
                        })}
                    </Row>
                 : null}
                 {categoryList.type === "linkList" ?
                    <List withLink listItems={categoryList.sub}/>
                 : null}
                 <p> </p>
                 <Accordion>
                 {contentAcc.map((a,index)=>{
                     return(
                        <Card>
                            <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                {a.title}
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={index+1}>
                                <Card.Body>{a.content}</Card.Body>
                            </Accordion.Collapse>
                        </Card>
                     )
                 })}
                 </Accordion>
            </Container>
        </div>
    
        <Footer/>
        </div>
        )
}